function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF4141;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6BBE66;} .st2{fill:#262626;}");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M97.57,29.08c13.98,0,25.31,11.33,25.31,25.31c0,13.98-11.33,25.31-25.31,25.31 c-13.98,0-25.31-11.33-25.31-25.31C72.26,40.42,83.59,29.08,97.57,29.08L97.57,29.08L97.57,29.08z M102.52,45.21 c1.13-1.15,2.97-1.16,4.11-0.01c1.14,1.14,1.14,3,0.01,4.15l-4.97,5.04l4.97,5.05c1.12,1.14,1.11,2.99-0.03,4.13 c-1.14,1.14-2.98,1.14-4.1-0.01l-4.94-5.01l-4.95,5.02c-1.13,1.15-2.97,1.16-4.11,0.01c-1.14-1.14-1.14-3-0.01-4.15l4.97-5.04 l-4.98-5.05c-1.12-1.14-1.11-2.99,0.03-4.13c1.14-1.14,2.98-1.14,4.1,0.01l4.94,5.01L102.52,45.21L102.52,45.21L102.52,45.21z"
}));

var SvgNo = function SvgNo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "70 35 55 35",
    style: {
      enableBackground: "new 0 0 122.88 79.71"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no.f0fce6c2.svg";
export { ForwardRef as ReactComponent };